export default {
  title: 'Opret ny adgangskode',
  description: 'Opret en ny adgangskode til din konto.',
  form: {
    new_password: {
      label: 'Ny adgangskode',
      placeholder: 'Indtast adgangskode',
      requirements: 'Din adgangskode skal indeholde 8 tegn, et stort bogstav og et tal',
    },
    confirm_password: {
      label: 'Bekræftelse af ny adgangskode',
      placeholder: 'Bekræft adgangskode',
    },
    error_messages: {
      missing_info: 'Manglende oplysninger',
    },
  },
  buttons: {
    update_password: 'Opdater adgangskode',
  },
};
